import { render, staticRenderFns } from "./arrangeTaskTwo.vue?vue&type=template&id=769390da&scoped=true"
import script from "./arrangeTaskTwo.vue?vue&type=script&lang=js"
export * from "./arrangeTaskTwo.vue?vue&type=script&lang=js"
import style0 from "./arrangeTaskTwo.vue?vue&type=style&index=0&id=769390da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769390da",
  null
  
)

export default component.exports